export default __webpack_public_path__ + "static/illustration_docs-9e4970954aff15d8f8bbc521622af8eb.svg";